import { render, staticRenderFns } from "./VBlockedList.vue?vue&type=template&id=312b721c&scoped=true"
import script from "./VBlockedList.vue?vue&type=script&lang=ts"
export * from "./VBlockedList.vue?vue&type=script&lang=ts"
import style0 from "./VBlockedList.vue?vue&type=style&index=0&id=312b721c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b721c",
  null
  
)

export default component.exports